import type { ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}